import React, { FC, memo } from 'react';
import { FormControl } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import { Header, Label, IconButton } from './group.styles';

type Props = {
  children: React.ReactNode;
  title?: string;
  className?: string;
  onClear?: () => void;
};

type RenderHeader = (title: string, onClear?: () => void) => JSX.Element;

type RenderClearButton = (onClear: () => void) => JSX.Element;

const renderClearButton: RenderClearButton = (onClear) => (
  <IconButton aria-label="close" onClick={onClear}>
    <CloseIcon />
  </IconButton>
);

const renderHeader: RenderHeader = (title, onClear) => (
  <Header container justifyContent="space-between" alignItems="center">
    <Label component="legend">{title}</Label>
    {onClear && renderClearButton(onClear)}
  </Header>
);

export const Group: FC<Props> = memo(
  ({ title, className, children, onClear }) => (
    <FormControl className={className} fullWidth component="fieldset">
      {title && renderHeader(title, onClear)}
      {children}
    </FormControl>
  )
);
